import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatToolbar } from '@angular/material/toolbar';
import { type IMedipassConfig } from '@medipass/partner-sdk';
import {
  ButtonsContainerComponent,
  TypedFormControl,
  TypedFormGroup,
} from '@principle-theorem/ng-shared';

export type IMedipassFormData = Pick<IMedipassConfig, 'apiKey'>;

@Component({
  selector: 'pr-medipass-integration-form',
  templateUrl: './medipass-integration-form.component.html',
  styleUrls: ['./medipass-integration-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatToolbar,
    MatDialogModule,
    MatFormField,
    MatLabel,
    MatInput,
    ButtonsContainerComponent,
    MatButton,
  ],
})
export class MedipassIntegrationFormComponent {
  medipassForm: TypedFormGroup<IMedipassFormData> =
    new TypedFormGroup<IMedipassFormData>({
      apiKey: new TypedFormControl<string>('', Validators.required),
    });

  constructor(
    private _dialogRef: MatDialogRef<MedipassIntegrationFormComponent>
  ) {}

  submit(): void {
    if (this.medipassForm.invalid) {
      return;
    }
    this._dialogRef.close(this.medipassForm.value);
  }
}
